/**
 * Приглушение звука чужой трансляции, пока говорю.
 *
 * Захват экрана отдаёт весь звук того компьютера, включая мой же голос, который туда прилетел
 * из Кличата, — и он возвращается ко мне эхом. Пока ворота микрофона открыты, звук трансляции
 * убавляется; отпускаем с задержкой, потому что эхо отстаёт на сеть и буферы и приходит уже
 * после того, как ворота закрылись.
 */
export interface Ducker {
  /** Ворота микрофона открылись или закрылись. */
  gate(open: boolean): void
  /** Множитель громкости звука трансляций: 1 — обычная, меньше — приглушено. */
  level(): number
  /** Снять приглушение сразу: выключили микрофон, вышли из канала, отключили настройку. */
  reset(): void
}

export const DUCK_LEVEL = 0.25
export const DUCK_RELEASE_MS = 1000

export function createDucker(onChange: () => void, releaseMs = DUCK_RELEASE_MS, level = DUCK_LEVEL): Ducker {
  let ducked = false
  let timer: ReturnType<typeof setTimeout> | null = null
  const stopTimer = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }
  return {
    gate(open) {
      stopTimer()
      if (open) {
        if (ducked) return
        ducked = true
        onChange()
        return
      }
      if (!ducked) return
      timer = setTimeout(() => {
        timer = null
        ducked = false
        onChange()
      }, releaseMs)
    },
    level: () => (ducked ? level : 1),
    reset() {
      stopTimer()
      if (!ducked) return
      ducked = false
      onChange()
    },
  }
}
